<template>
  <div class="stefan-boltzmann-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>j* = σ · T⁴ | 辐射功率与温度的四次方关系$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The radiator -->
          <circle cx="200" cy="120" :r="20 + temp*0.4" :fill="glowColor" :stroke="glowColor" :stroke-width="radiationIntensity">
             <animate attributeName="opacity" values="0.7;1;0.7" dur="1s" repeatCount="indefinite" />
          </circle>

          <!-- Photons Radiating outward -->
          <g v-for="n in photonCount" :key="n" :transform="`rotate(${n * (360/photonCount)}, 200, 120)`">
             <path d="M 230,120 L 300,120" stroke="#fff" stroke-width="1" opacity="0.3">
                <animateTransform attributeName="transform" type="translate" from="0,0" to="100,0" :dur="`${200/temp}s`" repeatCount="indefinite" />
             </path>
          </g>
          
          <text x="50" y="30" :fill="glowColor" font-size="10">辐射强度 P ∝ T⁴</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>表观温度 K: {{ (temp * 30).toFixed(0) }} K</label>
              <div class="value" style="color: #ff9f43">相对亮度: {{ Math.pow(temp/20, 4).toFixed(1) }}x</div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节温度 T</label>
             <el-slider v-model="temp" :min="10" :max="100" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>斯特藩-玻尔兹曼定律指出，一个黑体表面单位面积在单位时间内辐射出的总能量与其热力学温度的**四次方**成正比。这意味着温度仅仅增加一倍，辐射强度就会增加到原来的16倍。这就是为什么白炽灯丝（约3000K）发光极强，而常温下的物体（约300K）只能发出肉眼看不见的微弱红外辐射。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StefanBoltzmannViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      temp: 30
    }
  },
  computed: {
    glowColor() {
       if (this.temp < 40) return "#ff4757"; // Deep red
       if (this.temp < 70) return "#ff9f43"; // Orange/Yellow
       return "#ffffff"; // White hot
    },
    radiationIntensity() {
       return Math.pow(this.temp / 20, 2); // Visual approximation
    },
    photonCount() {
       return Math.floor(Math.pow(this.temp/20, 2) * 5);
    }
  }
}
</script>

<style scoped lang="scss">
.stefan-boltzmann-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 159, 67, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
